// @ts-expect-error ts-migrate(7016)
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error ts-migrate(7016)
import { getRichText } from 'conversations-message-history/initial-message/operators/initialMessageGetters';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
// @ts-expect-error ts-migrate(7016)
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import ContentText from '../../primary-message/ContentText';
import { Link } from 'foundations-components/transitional/components/Link';
import SlottedMessage from '../../slotted-message/SlottedMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AutomatedMessageAvatar from '../../avatar/AutomatedMessageAvatar';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const FeedbackSubmissionMessage = ({
  message,
  positionDescriptors,
  ungatedForThreadMessagesUIImprovements
}) => {
  const timestamp = getTimestamp(message);
  const submissionUrl = `${getFullUrl('app')}/feedback/${PortalIdParser.get()}/dashboard/manage/responses/${message.submissionId}`;
  return /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        positionDescriptors,
        use: AGENT,
        ungatedForThreadMessagesUIImprovements
      }
    },
    avatar: {
      Component: AutomatedMessageAvatar
    },
    title: {
      Component: FormattedMessage,
      componentProps: {
        message: 'conversations-inbox-message-history.responder.feedbackSubmission'
      }
    },
    timestamp: {
      componentProps: {
        timestamp
      }
    },
    body: {
      Component: ContentText,
      componentProps: {
        contentText: getRichText(message)
      }
    },
    footerBody: {
      Component: Link,
      componentProps: {
        use: 'blue',
        href: submissionUrl,
        truncate: true,
        external: true,
        truncateStringProps: {
          maxWidth: 500
        },
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: submissionUrl
        })
      }
    }
  });
};
FeedbackSubmissionMessage.displayName = 'FeedbackSubmissionMessage';
FeedbackSubmissionMessage.propTypes = {
  message: RecordPropType('FeedbackSubmissionMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default FeedbackSubmissionMessage;